import Checkbox from '@alexis/components/Checkbox';
import { clsx } from '@alexis/helpers/clsx';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import Price from '@components/Price';

import { getCurrencyState, getLocaleState } from '@redux/selectors';

import styles from './CheckboxItem.module.scss';

export type CheckboxItemProps = {
  isChecked: boolean;
  label: string;
  onCheckboxToggle: () => void;

  Icon?: ReactNode;
  className?: string;
  exchangeRate?: ExchangeRate;
  price?: Price;
};

const CheckboxItem: React.FC<CheckboxItemProps> = ({
  className,
  exchangeRate,
  Icon,
  isChecked,
  label,
  price,
  onCheckboxToggle,
}) => {
  const currency = useSelector(getCurrencyState);
  const locale = useSelector(getLocaleState);

  return (
    <div
      data-testid={`checkbox-${label}`}
      className={clsx(styles.item, className)}
      onClick={onCheckboxToggle}
    >
      <Checkbox className={styles.checkbox} isChecked={isChecked} />

      {Icon}

      <div className={clsx(styles.labelAndCount, className && styles.inDropdown)}>
        {label}

        {price && exchangeRate && currency && locale && (
          <Price
            isInline
            className={styles.price}
            price={price}
            locale={locale}
            currency={currency}
            exchangeRate={exchangeRate}
          />
        )}
      </div>
    </div>
  );
};

export default CheckboxItem;
